var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecklistIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C9.3 0 8.794 0.294 8.594 0.594C8.494 0.694 8.413 0.9 8.313 1H7C5.9 1 5 1.9 5 3H3C1.3 3 0 4.3 0 6V23C0 24.7 1.3 26 3 26H17C18.7 26 20 24.7 20 23V6C20 4.3 18.7 3 17 3H15C15 1.9 14.1 1 13 1H11.687C11.587 0.9 11.507 0.694 11.407 0.594C11.206 0.294 10.7 0 10 0ZM7 3H13V5H7V3ZM3 6H5.313C5.613 6.6 6.3 7 7 7H13C13.7 7 14.387 6.6 14.688 6H17V23H3V6ZM13.563 10.688C13.375 10.688 13.193 10.756 13.093 10.906L8.688 15.594L7 14C6.7 13.7 6.2 13.7 6 14L5.312 14.688C5.012 14.988 5.012 15.488 5.312 15.688L8.094 18.312C8.494 18.712 9.1 18.587 9.5 18.187L14.906 12.407C15.106 12.207 15.113 11.8 14.813 11.5L14.093 10.906C14.0234 10.8364 13.9408 10.7812 13.8499 10.7436C13.7589 10.706 13.6614 10.6878 13.563 10.688Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistIcon);
export default __webpack_public_path__ + "static/media/checklist_icon.9d08d3a88b065f6b9580866392ead2c9.svg";
export { ForwardRef as ReactComponent };